import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import axios from 'axios'
import qs from 'qs'

import { envUtils } from '../utils/envUtils'

const getBaseURL = () => {
  if (envUtils.localStrapiApiUrl) {
    return envUtils.localStrapiApiUrl
  }

  if (envUtils.isLive) {
    return `https://hcms.${domainProvider.TARGET_DOMAIN}/api`
  }
  return `https://hcms-staging.${domainProvider.TARGET_DOMAIN}/api`
}

export const strapi = axios.create({
  baseURL: getBaseURL(),
  params: {
    populate: '*',
  },
  paramsSerializer: (params) => qs.stringify(params),
})

strapi.interceptors.request.use((config) => {
  if (config.url?.match(/\?/g)) {
    throw Error('url에 parameter string넣지 말아주세요.')
  }

  return config
})
